module.exports = __webpack_public_path__ + "static/media/logoudea.ee922b96.svg";